import { render, staticRenderFns } from "./postLinkedin.vue?vue&type=template&id=51483e80&"
import script from "./postLinkedin.vue?vue&type=script&lang=js&"
export * from "./postLinkedin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports